module.exports = __webpack_public_path__ + "media/assets/images/logo_header-ade3010d517ae5ceb52f7d36a375597a.png";